import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    cell: {
        padding: 8,
        textAlign: 'center',
    },
    cellTime: {
        padding: 8,
        letterSpacing: -1,
        textAlign: 'center',
    },
  }));
  

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const LicenciasProfesional = ({items, title}) => {
    const classes = useStyles();

    return ( 
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <TableContainer component={Paper} style={{marginLeft: 20, marginRight: 20, marginBottom: 5}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" className={classes.cell}>Centro Médico</TableCell>
                                        <TableCell align="left" className={classes.cell}>Especialidad</TableCell>
                                        <TableCell align="left" className={classes.cell}>Fecha Desde</TableCell>
                                        <TableCell align="left" className={classes.cell}>Fecha Hasta</TableCell>
                                        <TableCell align="left" className={classes.cell}>Tipo Licencia</TableCell>
                                        <TableCell align="left"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {items.length > 0
                                        ?
                                            items.map((item) => (
                                                <TableRow key={item.idEfHorario}>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.centroMedico?.descripcionCentro}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.especialidad?.descripcionEspecialidades}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {new Date(item.fechaDesde).toLocaleString("es", optionsfecha)}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell} >
                                                        {new Date(item.fechaHasta).toLocaleString("es", optionsfecha)}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.tipoLicencia?.descripcion}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        :
                                            <TableRow className={{ height: 50 }}>
                                                <TableCell colSpan={12} className={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            
        </div>
     );
}